export default __webpack_public_path__ + "i18n/translations/translation.25b63e4f.json";